export const ROOT = "/";
export const OVERVIEW = "/overview";
export const DESIGN_API = "/design-api";
export const ON_BOARD = "/on-board";
export const REVIEW_SPEC = "/review-spec";
export const GLOBAL_SETTINGS = "/global-settings";
